import * as React from "react";


interface IFormProps {
    rooms_ids: any;
}
interface MyStates {

}
export default class DownstairsPlan extends React.Component<IFormProps, MyStates>{

    constructor(props:IFormProps) {
        super(props);

        this.state = {

        }
    }

    public render () {
        let rooms_ids = this.props.rooms_ids;
        return(
            <div className="box">
                <div className="box-header">
                    <h3 className="box-title text-center">Földszint</h3>
                </div>
                <div className="box-body">
                    <svg version="1.1" id="Layer_1"x="0px" y="0px" viewBox="0 0 1920 1080">
                        <g>
                            <rect x="196" y="252.8" className={rooms_ids.filter(id => id === 9).length > 0 ? "st1" : "st2"} width="181.3" height="213.5"/>
                            <text x="230" y="375" font-size="35" fill="#ECECEC">1.szoba</text>
                        </g>
                        <g>
                            <rect x="1428.4" y="252.8" className={rooms_ids.filter(id => id === 14).length > 0 ? "st1" : "st2"} width="295.6" height="232.9"/>
                            <text x="1508.4" y="372.8" font-size="35" fill="#ECECEC">4.szoba</text>
                        </g>
                        <g>
                            <rect x="1186.7" y="252.8" className={rooms_ids.filter(id => id === 13).length > 0 ? "st1" : "st2"} width="241.6" height="294.4"/>
                            <text x="1240.7" y="402.8" font-size="35" fill="#ECECEC">3.szoba</text>
                        </g>

                        <g>
                            <rect x="196" y="466.3" className={rooms_ids.filter(id => id === 12).length > 0 ? "st1" : "st2"} width="181.3" height="139.2"/>
                            <text x="226" y="536.3" font-size="35" fill="#ECECEC">2.szoba</text>
                        </g>


                        <polygon className="st2" points="1723.9,252.8 1723.9,728.4 1039.8,728.4 1039.8,827.2 363.6,827.2 363.6,605.5 196,605.5 196,252.8 "/>
                        <polyline className="st2" points="377.3,252.8 377.3,605.5 363.6,605.5 "/>
                        <line className="st2" x1="196" y1="466.3" x2="377.3" y2="466.3"/>
                        <line className="st2" x1="1186.8" y1="547.2" x2="1428.4" y2="547.2"/>
                        <line className="st2" x1="1428.4" y1="485.7" x2="1723.9" y2="485.7"/>
                        <line className="st2" x1="1428.4" y1="252.8" x2="1428.4" y2="550.1"/>
                        <line className="st2" x1="1186.8" y1="252.8" x2="1186.8" y2="550.1"/>
                    </svg>
                </div>
            </div>

        );
    }
}
